
import NodeCard from './node-card.vue'

export default {
  name: 'node',
  components: {NodeCard},
  inject: {
    di_last_answer: {default: true}
  },
  props: {
    node: {type: Object, required: true}
  },
  data() {
    return {
      expanded: this.di_last_answer
    }
  },
  computed: {
    has_children() {
      return !!this.node.children?.length
    }
  },
  watch: {
    di_last_answer(value) {
      if (!value) this.expanded = false
    }
  },
  methods: {
    toggle() {
      this.expanded = !this.expanded
    }
  }
}
